/*
 * Copyright 2025 coze-dev Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

export interface OntologyAppPublishFlag {
  app_id: string;
  sr_mapping_published?: boolean;
}

/**
 * 落库时要写入的本体应用 id。界面 store 仍保留原值，方便切回兼容模式时恢复。
 * apps 为 null 表示列表没拉到，原样返回，避免误清有效选择。
 * 本体数仓只接受已发布数仓映射的应用；本体模型不接受已发布数仓映射的应用。
 */
export function ontologyAppIdForPersistedMode(
  mode: 'ontology' | 'ontology_starrocks',
  appId: string,
  apps: OntologyAppPublishFlag[] | null,
): string {
  const trimmed = appId.trim();
  if (!trimmed || apps === null) {
    return trimmed;
  }
  const published =
    apps.find(app => app.app_id === trimmed)?.sr_mapping_published === true;
  if (mode === 'ontology_starrocks') {
    return published ? trimmed : '';
  }
  return published ? '' : trimmed;
}
